module.exports = __webpack_public_path__ + "Berthe faceset.png?3b6b9f9a05b23c34453ca89e7b492341";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Berthe faceset.png
// module id = 115
// module chunks = 0